export const PAYMENT_SCHEDULE_CREATE_MODAL = "PAYMENT_SCHEDULE_CREATE_MODAL"
export const PAYMENT_SCHEDULE_VIEW_MODAL = "PAYMENT_SCHEDULE_VIEW_MODAL"
export const PAYMENT_SCHEDULE_SIGN_MODAL = "PAYMENT_SCHEDULE_SIGN_MODAL"
export const PAYMENT_SCHEDULE_PROMISE_MODAL = "PAYMENT_SCHEDULE_PROMISE_MODAL"

export const REFINANCE_CONSENT_MODAL = "REFINANCE_CONSENT_MODAL"

export const PAYMENT_PAY_MODAL = "PAYMENT_PAY_MODAL"
export const BATCH_PAYMENT_PAY_MODAL = "BATCH_PAYMENT_PAY_MODAL"
export const SEPA_PAYMENT_PAY_MODAL = "SEPA_PAYMENT_PAY_MODAL"

export const PAYMENT_SUCCESS_MODAL = "PAYMENT_SUCCESS_MODAL"
export const PAYMENT_FAILURE_MODAL = "PAYMENT_FAILURE_MODAL"

export const SUBSCRIPTION_CREATE_MODAL = "SUBSCRIPTION_CREATE_MODAL"
export const SUBSCRIPTION_UPGRADE_MODAL = "SUBSCRIPTION_UPGRADE_MODAL"

export const SUBSCRIPTION_CANCEL_MODAL = "SUBSCRIPTION_CANCEL_MODAL"
export const SUBSCRIPTION_BANK_MODAL = "SUBSCRIPTION_BANK_MODAL"

export const SUBSCRIPTION_SUCCESS_MODAL = "SUBSCRIPTION_SUCCESS_MODAL"
export const SUBSCRIPTION_FAILURE_MODAL = "SUBSCRIPTION_FAILURE_MODAL"

export const ISSUE_CREATE_MODAL = "ISSUE_CREATE_MODAL"

export const PRODUCT_PAYMENT_MODAL = "PRODUCT_PAYMENT_MODAL"

export const PRODUCT_PAYMENT_SUCCESS_MODAL = "PRODUCT_PAYMENT_SUCCESS_MODAL"
export const PRODUCT_PAYMENT_FAILURE_MODAL = "PRODUCT_PAYMENT_FAILURE_MODAL"

export const HELP_HOW_MODAL = "HELP_HOW_MODAL"
export const HELP_WHY_MODAL = "HELP_WHY_MODAL"
export const HELP_WHEREFORE_MODAL = "HELP_WHEREFORE_MODAL"
export const HELP_WHAT_MODAL = "HELP_WHAT_MODAL"
